// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Usuarios_ListAvailableGroupsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /usuarios/list_available_groups
 *
 * Returns all available Cognito user groups.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Usuarios_ListAvailableGroupsResponseDados {
items: string[]
}

export type Usuarios_ListAvailableGroupsResponse = ApiResponse<Usuarios_ListAvailableGroupsResponseDados>;

registerResponseContract('Usuarios_ListAvailableGroupsResponse', {
  items: { type: 'array',   required: true },
})
